import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { HttpClient, HttpResponse ,HttpHeaders} from '@angular/common/http';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { LOGIN_DOWNLOAD_TEACHER_APP , LOGIN_DOWNLOAD_STUDENT_APP ,LOGIN_APPLE_STORE_LINK , LOGIN_PLAYSTORE_LINK }  from 'src/app/constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isSubmitted = false;
  userEmail: string;
  password: string;
  hostID: string;
  token_data: string;
  userID: string;
  verifiedStatus: string;
  errormsg: string;
  text1:string;
  text2:string;
  appleLink:string;
  playstoreLink:string;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService
    ) {
    this.loginForm = this.formBuilder.group({
      userEmail: ['', Validators.required],
      password: ['', Validators.required]
    });


  }

  ngOnInit() {
    this.text1= LOGIN_DOWNLOAD_TEACHER_APP;
    this.text2 = LOGIN_DOWNLOAD_STUDENT_APP;
    this.appleLink = LOGIN_APPLE_STORE_LINK;
    this.playstoreLink = LOGIN_PLAYSTORE_LINK;

  }

  register() {
    this.router.navigateByUrl(`register`);
  }

  onForgetPassword(){
   this.router.navigateByUrl(`forgotpassword`); 
  }
  checkField(field) {
    const formField = this.loginForm.controls[field];

    return formField.invalid && (formField.touched || this.isSubmitted);
  }

  async onLogin() {
    this.isSubmitted = false;
    

    if (this.userEmail == undefined) {
      alert("Please Enter Email Address");
      return;
    }
    else if (this.password == undefined) {
      alert("Please Enter Password");
      return;
    }

    else {

      

      let hostData =
      {
        userEmail: this.userEmail,
        password: this.password
      }

      this.apiService.hostLogin(hostData).subscribe(async (res: any) => {        
        this.hostID = res.data.hostID;
        this.token_data = res.data.token_data;
        this.userID = res.data.userID;

        //localStorage.setItem("hostID", this.hostID);
        //localStorage.setItem(this.helperService.setToken(this.token_data));
        this.helperService.setToken(this.helperService.studented_btoa(this.token_data));
        this.helperService.setUserID(this.helperService.studented_btoa(this.userID));
        this.helperService.setHostID(this.helperService.studented_btoa(this.hostID));
        //localStorage.setItem("userID", this.userID);
        let userdata = {
          //token:this.helperService.studented_atob(this.helperService.getToken()) ,
          userID:this.helperService.studented_atob(this.helperService.getUserID())
        }

        this.apiService.checkUser(userdata).subscribe(async (res: any) => {          
          this.userID = res.data.userStatus.data.id;
          this.verifiedStatus = res.data.userStatus.data.verifiedStatus;

        }, async err => {

        })
        this.router.navigateByUrl(`search`);
        //alert("Successful Login");
      }, async err => {

        this.errormsg = err.error.meta.msg;
        alert(this.errormsg);

        this.router.navigateByUrl(`login`);


      })


    }
  }

}
